import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/work-calendar/coaches/")({
  head: () => ({
    meta: [{ title: "教练日历 · imiker CRM" }],
  })
});
